import React from "react";
import { StyledTextField } from "./styled";

const TextFieldInput = (props: any) => {
  return (
    <StyledTextField
      fullWidth
      label={props.label}
      variant={props.variant}
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      autoFocus={props?.autoFocus}
      error={props?.error}
      helperText={props?.helperText}
      InputProps={props?.InputProps}
      multiline={props?.multiline}
      rows={props?.rows}
    />
  );
};

export default TextFieldInput;
